export function createPromiseCancellationToken() {
    var cancel = function () { };
    var cancellationPromise = new Promise(function (resolve) {
        cancel = resolve;
    });
    return {
        cancel: cancel,
        onCancel: function (onCancel) {
            return cancellationPromise.then(onCancel);
        },
    };
}
//# sourceMappingURL=createPromiseCancellationToken.js.map